import classNames from 'classnames';
import React,{Component} from 'react';
import './Copy.css';

interface Props{
    copy:string
    className?:string
}

interface State{
    copied: boolean
    focused: boolean
}


export default class Copy extends Component<Props, State>{
    state={
        copied: false,
        focused: false
    }
    render(){
        let copied = this.state.copied && this.state.focused;
        return (
            <div
                tabIndex={0}
                onFocus={()=>{ this.setState({ focused: true }) }}
                onBlur={()=>{ this.setState({ focused: false }) }}
                className={classNames({
                    "tt copy": true,
                    "copied": copied,
                }) + " " + this.props.className} 
                onClick={this.copy}
            >
                <i className="fas fa-copy"/>
                {
                    copied?
                    <div className="tt-tooltip constant">
                        Copied!
                    </div>
                    :
                    <div className="tt-tooltip">
                        Copy
                    </div>
                }
            </div>
        );
    }

    copy = () =>{
        navigator.clipboard.writeText(this.props.copy)
        .then(()=>{
            this.setState({ copied: true })
        })
    }
};

